import React, { useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import CallControls from "../../../components/calls/CallControls";
import CallDetails from "../../../components/calls/CallDetails";
import MiniCallScreen from "../../../components/calls/MiniCallScreen";
import "./index.scss";

interface CallScreenProps {}

const CallScreen: React.FC<CallScreenProps> = () => {
  const [showCallScreen, setShowCallScreen] = useState(true);
  const { calls, currentCallId } = useSelector((state: RootState) => state.sip);
  const onGoingCalls = Object.keys(calls);
  const acceptedCalls = Object.values(calls).filter(
    (call: any) => call.status === "in-progress"
  ).length;

  if (
    !currentCallId ||
    !calls[currentCallId] ||
    (calls[currentCallId].status !== "in-progress" &&
      calls[currentCallId].status !== "calling") ||
    calls[currentCallId]?.isGroupCall
  ) {
    return <></>;
  }

  return (
    <>
      {showCallScreen ? (
        <div
          className={`call-screen-wrapper ${
            !onGoingCalls.length || !currentCallId ? "display-none" : ""
          }`}
        >
          {onGoingCalls.length > 0 && currentCallId ? (
            <div className="calls-screen">
              <ArrowLeftOutlined
                className="back-icon"
                onClick={() => setShowCallScreen(false)}
              />
              <div
                className="calls-grid"
                style={{
                  gridTemplateColumns: `repeat(${acceptedCalls}, 1fr)`,
                }}
              >
                {onGoingCalls.map((callId) => {
                  const call = calls[callId];
                  if (
                    call.status === "calling" ||
                    call.status === "in-progress"
                  ) {
                    return (
                      <CallDetails
                        key={callId}
                        setIsFullScreen={setShowCallScreen}
                        currentCall={calls[callId]}
                      />
                    );
                  }
                  return <></>;
                })}
              </div>
              <CallControls currentCall={calls[currentCallId]} />
            </div>
          ) : null}
        </div>
      ) : (
        <MiniCallScreen
          onClick={() => setShowCallScreen(true)}
          numberOfCalls={onGoingCalls.length}
          currentCall={calls[currentCallId]}
        />
      )}
    </>
  );
};

export default CallScreen;
